import React, { useEffect, useState } from "react";
import api from "../services/api";

function AccessControl() {

const [stats,setStats] = useState({});
const [students,setStudents] = useState([]);

const [industry,setIndustry] = useState("");
const [course,setCourse] = useState("");
const [batch,setBatch] = useState("");
const [startDate,setStartDate] = useState("");
const [endDate,setEndDate] = useState("");

useEffect(()=>{

loadDashboard();

},[]);


/* DASHBOARD */

const loadDashboard = async ()=>{

try{

const res = await api.get("/access/dashboard");

console.log("Dashboard:",res.data);

setStats(res.data.data);

}catch(err){

console.log("Dashboard error:",err);

}

};


/* FILTER */

const applyFilter = async ()=>{

try{

const res = await api.post("/access/filter",{

industry_id:industry || null,
course_id:course || null,
batch:batch || null,
start_date:startDate || null,
end_date:endDate || null

});

setStudents(res.data.data);

}catch(err){

console.log(err);

}

};


return(

<div style={{maxWidth:"1200px"}}>

<h2>Access Control</h2>

<p>Assign courses to students</p>


{/* DASHBOARD */}

<div style={{display:"flex",gap:"40px",marginTop:"20px"}}>

<div>
<b>Total Students</b>
<div>{stats?.total_students || 0}</div>
</div>

<div>
<b>Active Accounts</b>
<div>{stats?.active_students || 0}</div>
</div>

<div>
<b>Inactive Accounts</b>
<div>{stats?.inactive_students || 0}</div>
</div>

<div>
<b>Total Access</b>
<div>{stats?.total_access || 0}</div>
</div>

</div>


{/* FILTERS */}

<div style={{marginTop:"40px"}}>

<h3>Filters</h3>

<div style={{display:"flex",gap:"10px",flexWrap:"wrap"}}>

<input
placeholder="Batch"
value={batch}
onChange={(e)=>setBatch(e.target.value)}
/>

<input
type="date"
value={startDate}
onChange={(e)=>setStartDate(e.target.value)}
/>

<input
type="date"
value={endDate}
onChange={(e)=>setEndDate(e.target.value)}
/>

<button onClick={applyFilter}>
Apply Filter
</button>

</div>

</div>


{/* RESULTS */}

<div style={{marginTop:"40px"}}>

<h3>Filtered Students : {students.length}</h3>

<table border="1" width="100%" cellPadding="10">

<thead>

<tr>

<th>#</th>
<th>Name</th>
<th>Email</th>
<th>Mobile</th>
<th>Batch</th>
<th>Account</th>
<th>Active Courses</th>
<th>Inactive Courses</th>

</tr>

</thead>

<tbody>

{students.map((s,index)=>(

<tr key={s.id}>

<td>{index+1}</td>

<td>{s.first_name} {s.last_name}</td>

<td>{s.email}</td>

<td>{s.mobile}</td>

<td>{s.batches}</td>

<td>

<span style={{
background:s.status==="active"?"green":"red",
color:"white",
padding:"3px 8px"
}}>

{s.status}

</span>

</td>

<td>

<span style={{
background:"green",
color:"white",
padding:"3px 8px"
}}>

{s.active_courses || 0}

</span>

</td>

<td>

<span style={{
background:"red",
color:"white",
padding:"3px 8px"
}}>

{s.inactive_courses || 0}

</span>

</td>

</tr>

))}

</tbody>

</table>

</div>

</div>

);

}

export default AccessControl;